import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Empty,
  Form,
  Input,
  Row,
  Table,
  Tooltip,
  Modal,
} from "antd";
import { LoadingOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { get_language, translate } from "../../locale";
import UserServices from "../../services/UserServices";
import moment from "moment";
import { TableHelper } from "../../helpers/TableHelper";
import AddPill from "../Modals/AddPill";
import { useParams } from "react-router-dom";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const PillsTable = ({ reload, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalDetails, setModalDetails] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
    searchText: "",
  });
  const [total, setTotal] = useState(0);
  const [showAddPill, setShowAddPill] = useState(false);
  const [pillToEdit, setPillToEdit] = useState({});
  const [modalVisible, setModalVisible] = useState(false);

  const { username } = useParams();

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 70,
      render: (text, record, index) => (
        <div className="flex space-x-2">
          <Tooltip title="Editar" color="blur">
            <Button
              onClick={() => {
                setShowAddPill(true);
                setPillToEdit(record);
              }}
              type="text"
              icon={<EditOutlined />}
              size="small"
              className="border-0"
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: translate("Nombre"),
      dataIndex: "name",
      key: "name",
      sorter: { multiple: 3 },
    },
    {
      title: translate("Descripción"),
      dataIndex: "description",
      key: "description",
      render: (_, record) => record.description,
      sorter: { multiple: 2 },
    },
    {
      title: translate("Url"),
      dataIndex: "url",
      key: "url",
      render: (_, record) => record.url,
      sorter: { multiple: 1 },
    },
  ];

  useEffect(() => {}, []);

  const handleOnCancelPill = () => {
    setShowAddPill(false);
    setPillToEdit({});
  };

  useEffect(() => {
    loadData();
  }, [JSON.stringify(tableParams), showAddPill]);

  const loadData = async () => {
    setLoading(true);
    let data = {
      page_size: tableParams.pagination.pageSize,
      page_num: tableParams.pagination.current,
    };
    const sorter = TableHelper.sorter(tableParams);
    if (sorter !== null) {
      data = { ...data, order_by: sorter };
    }
    if (tableParams.searchText !== "") {
      data = { ...data, name: tableParams.searchText };
    }
    try {
      const response = await UserServices.getPill(data);
      if (response.status >= 200 && response.status < 300) {
        setData(response.data.pills);
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleShowDetails = (data) => {
    setModalDetails(true);
    setSelectedData(data);
  };

  const handleHideDetails = () => {
    setModalDetails(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleModalComplete = () => {
    // update user list
    setModalVisible(false);
    loadData();
  };

  const handleAddPill = () => {
    setModalVisible(true);
  };
  const searchData = (value) => {
    setTableParams((v) => ({
      pagination: {
        ...v.pagination,
        current: 1,
      },
      searchText: value,
    }));
  };

  return (
    <>
      <Row gutter={16}>
        <Col className="gutter-row" span="18">
          <div className="text-start">
            <Button
              type="primary"
              className="bg-custom_primary border-custom_primary"
              onClick={handleAddPill}
            >
              {translate("Agregar píldora")}
            </Button>
            <AddPill
              patient={username}
              visible={modalVisible}
              onCancel={handleModalCancel}
              onComplete={handleModalComplete}
            />
          </div>
        </Col>
        <Col span="6" className="mb-4">
          <Form>
            <Form.Item>
              <Input.Search
                allowClear
                placeholder={translate("Buscar")}
                onSearch={searchData}
              />
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Table
        rowKey={(i) => {
          return i.id.toString();
        }}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />
      <Modal
        open={modalDetails}
        title={translate("Píldora")}
        onCancel={handleHideDetails}
        footer={[
          <Button key="ok" type="primary" onClick={handleHideDetails}>
            {translate("Aceptar")}
          </Button>,
        ]}
      >
        {selectedData !== null && (
          <>
            <p>
              <strong>{translate("Fecha")}: </strong>{" "}
              {moment(selectedData.date).format(
                get_language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
              )}
              <br />
              <strong>{translate("Remitente")}: </strong>{" "}
              {selectedData.sender.username}
              <br />
              <strong>{translate("Título")}: </strong> {selectedData.pill.name}
              <br />
              <strong>{translate("Descripción")}: </strong>
            </p>
            {selectedData.pill.description}
          </>
        )}
      </Modal>

      <AddPill
        visible={showAddPill}
        onCancel={handleOnCancelPill}
        onComplete={handleOnCancelPill}
        pillToEdit={pillToEdit}
      />
    </>
  );
};

export default PillsTable;
